import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { mdToHtml } from "../lib/md";

export const AiHtml = ({ text, className = "", testId }) => (
  <div data-testid={testId} className={`ai-prose ${className}`} dangerouslySetInnerHTML={{ __html: mdToHtml(text) }} />
);

export const CopyButton = ({ text, label = "Copy", testId }) => {
  const [done, setDone] = useState(false);
  return (
    <button
      data-testid={testId}
      onClick={() => {
        navigator.clipboard.writeText(text);
        setDone(true);
        setTimeout(() => setDone(false), 1500);
      }}
      className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full border border-slate-700 text-slate-300 hover:border-orange-500 hover:text-orange-400 transition-colors"
    >
      {done ? <Check size={14} /> : <Copy size={14} />} {done ? "Copied" : label}
    </button>
  );
};

export const Pills = ({ options, value, onChange, testPrefix }) => (
  <div className="flex flex-wrap gap-2">
    {options.map((o) => {
      const v = typeof o === "string" ? o : o.value;
      const l = typeof o === "string" ? o : o.label;
      return (
        <button key={v} data-testid={`${testPrefix}-${v.replace(/[^a-z0-9]/gi, "")}`} onClick={() => onChange(v)} className={`pill ${value === v ? "pill-on" : "pill-off"}`}>
          {l}
        </button>
      );
    })}
  </div>
);

export const Spinner = ({ label = "Working on it..." }) => (
  <div data-testid="loading-spinner" className="flex flex-col items-center justify-center gap-4 py-16 text-slate-400">
    <div className="w-12 h-12 rounded-full border-4 border-slate-800 border-t-orange-500 animate-spin" />
    <p className="text-sm font-mono">{label}</p>
  </div>
);

export const Section = ({ title, children, right, testId }) => (
  <div data-testid={testId} className="card-n p-5 fade-up">
    {(title || right) && (
      <div className="flex items-center justify-between gap-3 border-b border-slate-800 pb-3 mb-4">
        <h3 className="text-base font-semibold text-slate-100">{title}</h3>
        {right}
      </div>
    )}
    {children}
  </div>
);

export const PageHeader = ({ label, title, desc, right }) => (
  <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
    <div>
      <p className="label-mono mb-2">{label}</p>
      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-50">{title}</h1>
      {desc && <p className="text-sm text-slate-400 mt-2 max-w-2xl">{desc}</p>}
    </div>
    {right}
  </div>
);

export const Cost = ({ n }) => <span className="badge-o" data-testid="task-cost-badge">{n} credits</span>;
